import "./styles/app.sass";
import "./styles/style.css";
import "draft-js/dist/Draft.css";
import "@draft-js-plugins/focus/lib/plugin.css";
import "@draft-js-plugins/image/lib/plugin.css";
import RouteList from "./route";
import { UserProvider } from "./context";
import GlobalToaster from "./components/Toaster";

function App() {
	return (
		<>
			<UserProvider>
				<RouteList />
			</UserProvider>
			<GlobalToaster />
		</>
	);
}

export default App;
